import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoBack, LazySvgoBriefcase, LazySvgoCheck, LazySvgoChevronLeft, LazySvgoChevronRight, LazySvgoClose2, LazySvgoClose, LazySvgoComment, LazySvgoCopy, LazySvgoDown, LazySvgoEducation, LazySvgoGlobe, LazySvgoGoBack, LazySvgoHash, LazySvgoHeroProofAllLithuania, LazySvgoHeroProofClearPricing, LazySvgoHeroProofDirectContact, LazySvgoHeroProofFastSearch, LazySvgoHeroProofMoreConfidence, LazySvgoHeroProofTrustedProfiles, LazySvgoHeroProofVerifiedReviews, LazySvgoHeroProofWorkExamples, LazySvgoInfo2, LazySvgoInfo, LazySvgoLayout, LazySvgoLink, LazySvgoLogo, LazySvgoMail, LazySvgoMapPin, LazySvgoMore, LazySvgoPencil, LazySvgoPhone, LazySvgoSearchCategory, LazySvgoSearchCity, LazySvgoSearchField, LazySvgoSearchService, LazySvgoSearch, LazySvgoSignin, LazySvgoSliders, LazySvgoSort, LazySvgoStar, LazySvgoStartOutline, LazySvgoThumbsUp, LazySvgoUser, LazySvgoUserCheck, LazySvgoVerified, LazySvgoWarning, LazySvgoWork, LazySvgoX, LazySvgoXThin } from '#components'
const lazyGlobalComponents = [
  ["SvgoBack", LazySvgoBack],
["SvgoBriefcase", LazySvgoBriefcase],
["SvgoCheck", LazySvgoCheck],
["SvgoChevronLeft", LazySvgoChevronLeft],
["SvgoChevronRight", LazySvgoChevronRight],
["SvgoClose2", LazySvgoClose2],
["SvgoClose", LazySvgoClose],
["SvgoComment", LazySvgoComment],
["SvgoCopy", LazySvgoCopy],
["SvgoDown", LazySvgoDown],
["SvgoEducation", LazySvgoEducation],
["SvgoGlobe", LazySvgoGlobe],
["SvgoGoBack", LazySvgoGoBack],
["SvgoHash", LazySvgoHash],
["SvgoHeroProofAllLithuania", LazySvgoHeroProofAllLithuania],
["SvgoHeroProofClearPricing", LazySvgoHeroProofClearPricing],
["SvgoHeroProofDirectContact", LazySvgoHeroProofDirectContact],
["SvgoHeroProofFastSearch", LazySvgoHeroProofFastSearch],
["SvgoHeroProofMoreConfidence", LazySvgoHeroProofMoreConfidence],
["SvgoHeroProofTrustedProfiles", LazySvgoHeroProofTrustedProfiles],
["SvgoHeroProofVerifiedReviews", LazySvgoHeroProofVerifiedReviews],
["SvgoHeroProofWorkExamples", LazySvgoHeroProofWorkExamples],
["SvgoInfo2", LazySvgoInfo2],
["SvgoInfo", LazySvgoInfo],
["SvgoLayout", LazySvgoLayout],
["SvgoLink", LazySvgoLink],
["SvgoLogo", LazySvgoLogo],
["SvgoMail", LazySvgoMail],
["SvgoMapPin", LazySvgoMapPin],
["SvgoMore", LazySvgoMore],
["SvgoPencil", LazySvgoPencil],
["SvgoPhone", LazySvgoPhone],
["SvgoSearchCategory", LazySvgoSearchCategory],
["SvgoSearchCity", LazySvgoSearchCity],
["SvgoSearchField", LazySvgoSearchField],
["SvgoSearchService", LazySvgoSearchService],
["SvgoSearch", LazySvgoSearch],
["SvgoSignin", LazySvgoSignin],
["SvgoSliders", LazySvgoSliders],
["SvgoSort", LazySvgoSort],
["SvgoStar", LazySvgoStar],
["SvgoStartOutline", LazySvgoStartOutline],
["SvgoThumbsUp", LazySvgoThumbsUp],
["SvgoUser", LazySvgoUser],
["SvgoUserCheck", LazySvgoUserCheck],
["SvgoVerified", LazySvgoVerified],
["SvgoWarning", LazySvgoWarning],
["SvgoWork", LazySvgoWork],
["SvgoX", LazySvgoX],
["SvgoXThin", LazySvgoXThin],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
